import type { StateOperator } from '@ngxs/store';
import { produce } from 'immer';

export function immutableSetState<T>(
  setState: (val: T | StateOperator<T>) => void,
  draft: (draft: Readonly<T>) => void,
) {
  // any azert kell ide, mert complex az immer tipus leiroja es ami kell hozza az nincs exportalva
  setState(produce(draft) as any);
}
